import type { EventItem } from "../types/api";

type EventAdmissionLabelSource = Pick<EventItem, "admissionType">;

export function isRegistrationEvent(event?: EventAdmissionLabelSource | null) {
  return event?.admissionType === "registration";
}

export function getEventPrimaryActionLabel(event?: EventAdmissionLabelSource | null) {
  return isRegistrationEvent(event) ? "Register now" : "Buy Tickets";
}

export function getEventAuthActionLabel(event: EventAdmissionLabelSource, isSignedIn: boolean) {
  if (isRegistrationEvent(event)) {
    return isSignedIn ? "Register now" : "Sign in to register";
  }

  return isSignedIn ? "Buy Tickets" : "Sign in to buy tickets";
}
